import React from 'react';
import { Card, Field, TextField, SaveButton } from '../AdminUI';
import { useSite } from '../../../context/SiteContext';
import { toast } from 'sonner';

export default function ModalsSection() {
  const { data, update } = useSite();
  const [login, setLogin] = React.useState(data.loginModal);
  const [signup, setSignup] = React.useState(data.signupModal);
  const [right, setRight] = React.useState(data.rightPanel);

  // Sync from server data only on mount; otherwise live polling would
  // overwrite the admin's in-progress edits.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => { setLogin(data.loginModal); setSignup(data.signupModal); setRight(data.rightPanel); }, []);

  const save = () => {
    update((p) => ({ ...p, loginModal: login, signupModal: signup, rightPanel: right }));
    toast.success('Saved successfully');
  };

  const sl = (k, v) => setLogin({ ...login, [k]: v });
  const ss = (k, v) => setSignup({ ...signup, [k]: v });
  const sr = (k, v) => setRight({ ...right, [k]: v });

  return (
    <>
      <Card title="Login Modal" desc="All labels and button text inside the Login modal." footer={<SaveButton onClick={save} />}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {Object.entries(login).map(([k, v]) => (
            <Field key={k} label={k}><TextField value={v} onChange={(val) => sl(k, val)} /></Field>
          ))}
        </div>
      </Card>

      <Card title="Sign Up Modal" footer={<SaveButton onClick={save} />}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {Object.entries(signup).map(([k, v]) => (
            <Field key={k} label={k}><TextField value={v} onChange={(val) => ss(k, val)} /></Field>
          ))}
        </div>
      </Card>

      <Card title="Right Side Betslip Panel" footer={<SaveButton onClick={save} />}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {Object.entries(right).map(([k, v]) => (
            <Field key={k} label={k}><TextField value={v} onChange={(val) => sr(k, val)} /></Field>
          ))}
        </div>
      </Card>
    </>
  );
}
